<template>
  <transition name="fade">
    <div
      v-if="visibility"
      class="ftn-overlay"
      @click.self="close"
    >
      <div role="alert">
        <h2 v-html="text"></h2>
        <div>
          <TButton
            v-if="okText"
            type="button"
            variant="danger"
            :loading="loading"
            @click="handleSubmit"
          >
            {{ okText }}
          </TButton>

          <TButton
            v-if="!loading"
            type="button"
            variant="secondary"
            :disabled="loading"
            @click="handleOnCancelClick"
          >
            {{ cancelText }}
          </TButton>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TButton from '@/components/base/TButton/TButton.vue';

export default {
  name: 'OverlayConfirm',
  components: {
    TButton,
  },
  model: {
    prop: 'visibility',
    event: 'close',
  },
  props: {
    visibility: {
      type: Boolean,
      required: true,
    },
    submit: {
      type: Function,
      default: () => null,
    },
    text: {
      type: String,
      default: 'Are you sure?',
    },
    okText: {
      type: String,
      default: 'Delete',
    },
    cancelText: {
      type: String,
      default: 'Cancel',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async handleSubmit() {
      try {
        this.loading = true;
        await this.submit();
      } finally {
        this.loading = false;
        this.close();
      }
    },
    close() {
      this.$emit('close', false);
    },
    handleOnCancelClick() {
      this.$emit('cancel');
      this.close();
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/scss/mixins";

[role="alert"] {
  max-width: 358px;
  padding: 24px;

  background-color: var(--light);
  border-radius: calc(var(--border-radius) * 2);

  @include media-lg() {
    padding: 32px 48px;
  }

  h2 {
    margin-bottom: 32px;

    @include font-lg_plus(500);

    @include media-lg() {
      margin-bottom: 24px;

      text-align: center;
    }
  }

  > div {
    display: flex;
    flex-direction: column;

    @include media-lg() {
      flex-direction: row-reverse;
      justify-content: center;
    }

    > * {
      &:not(:last-child) {
        margin-bottom: 16px;

        @include media-lg() {
          margin-bottom: 0;
          margin-left: 16px;
        }
      }
    }
  }
}
</style>
